var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.28571C0 3.14907 0.451529 2.05898 1.25526 1.25526C2.05898 0.451529 3.14907 0 4.28571 0H6.24571C7.47429 0 8.54571 0.837143 8.84429 2.02857L10.4229 8.34714C10.5508 8.85857 10.5249 9.39637 10.3486 9.89318C10.1722 10.39 9.85318 10.8237 9.43143 11.14L7.58429 12.5257C7.39143 12.67 7.35 12.8814 7.40429 13.0286C8.21054 15.2212 9.48371 17.2124 11.1356 18.8644C12.7876 20.5163 14.7788 21.7895 16.9714 22.5957C17.1186 22.65 17.3286 22.6086 17.4743 22.4157L18.86 20.5686C19.1763 20.1468 19.61 19.8278 20.1068 19.6514C20.6036 19.4751 21.1414 19.4492 21.6529 19.5771L27.9714 21.1557C29.1629 21.4543 30 22.5257 30 23.7557V25.7143C30 26.8509 29.5485 27.941 28.7447 28.7447C27.941 29.5485 26.8509 30 25.7143 30H22.5C10.0743 30 0 19.9257 0 7.5V4.28571Z",
    fill: "currentColor"
  })));
};
export default SvgPhone;